import { Fragment, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import SocialAdsBuilderModal from './SocialAdsBuilderModal';

const defaultPost = {
  image: 'https://i.ibb.co/82xMFc1/NOV002-2-07abbaea-3e7d-4c61-8034-9d6593ae1833-1080x.webp',
  content: 'معاً نكرم محاربينا القدامى. استمتع بخصم 25% على جميع الطلبات واجعل هذا الموسم لا ينسى'
};

function SocialPostModal({ isOpen, onClose }) {
  const [postContent, setPostContent] = useState(defaultPost);
  const [showSocialAdsBuilder, setShowSocialAdsBuilder] = useState(false);

  const handleGenerate = () => {
    // TODO: Implement image generation
    console.log('Generating with prompt:', prompt);
  };

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md">
                <div className="absolute right-0 top-0 pr-4 pt-4">
                  <button
                    type="button"
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500"
                    onClick={onClose}
                  >
                    <span className="sr-only">Close</span>
                    <XMarkIcon className="h-6 w-6" />
                  </button>
                </div>

                <div className="p-6">
                  <div className="max-w-md mx-auto">
                    <div className="bg-white rounded-lg overflow-hidden">
                      {/* Profile Header */}
                      <div className="flex items-center space-x-2 p-4">
                        <img
                          src="https://i.ibb.co/YkwGqLQ/Screenshot-2024-11-14-at-3-38-45-PM-removebg-preview-1.png"
                          alt="Profile"
                          className="w-10 h-10 rounded-full"
                        />
                        <div>
                          <div className="font-semibold">rinawi</div>
                          <div className="text-sm text-gray-500">Just now</div>
                        </div>
                      </div>

                      {/* Post Content */}
                      <div className="px-4">
                        <p className="text-sm mb-4" dir="rtl">{postContent.content}</p>
                        <img
                          src={postContent.image}
                          alt="Post"
                          className="w-full rounded-lg"
                        />

                        {/* Engagement Stats */}
                        <div className="flex items-center justify-between mt-4 py-3 border-t border-gray-200">
                          <div className="flex items-center space-x-2">
                            <span className="text-sm text-gray-500">216</span>
                          </div>
                          <div className="flex items-center space-x-4 text-sm text-gray-500">
                            <span>117 comments</span>
                            <span>44 shares</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="flex justify-end space-x-4 mt-6">
                    <button
                      onClick={handleGenerate}
                      className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600"
                    >
                      Save Generation
                    </button>
                    <button
                      onClick={() => setShowSocialAdsBuilder(true)}
                      className="px-4 py-2 bg-[#0049ac] text-white rounded-lg hover:bg-[#0049ac]/90"
                    >
                      Generate New Image
                    </button>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>

        <SocialAdsBuilderModal 
          isOpen={showSocialAdsBuilder} 
          onClose={() => setShowSocialAdsBuilder(false)} 
        />
      </Dialog>
    </Transition.Root>
  );
}

export default SocialPostModal;